module.exports = function() {
  return new Worker("/" + "typescript-transpiler.fd5b7daf.worker.js");
};